<template>
  <div>
    <div class="top-navbar">
      <a href="javascript:closePage()" class="back-arrow">
        <i class="icon dripicons-chevron-left"></i>
      </a>
      {{ $t('statement') }}
    </div>
    <div class="container" style="padding-bottom: 50px;">
      <a
        v-for="(row, index) in content" :key="index"
        class="statement-card"
      >
        <div class="card-title lrspan">
          <table width="100%">
            <tbody>
              <tr>
                <td style="text-align:left;">
                  {{ row.betDate }}
                </td>
                <td style="text-align:right;">
                  <div class="smallBtn icon-next color-green" :title="$t('view_detail')" @click="showDetail(row.betDate)">
                    {{ $t('view_detail') }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="lrspan">
          <div>
            <span>{{ $t('sum_bet') }}: </span>&nbsp;
            <span style="color:green;">{{ Number(row.amountTotal).toLocaleString() }}</span>
          </div>
          <div>
            <span>{{ $t('winloss') }}: </span>&nbsp;
            <span :style="[row.amountWinTotal > 0 ? { 'color': 'green' } : { 'color': 'red' }]">
            {{ formatAmountWinTotal(row.amountWinTotal) }}
            </span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import i18n from "@src/i18n";

export default {
  computed: {
    ...mapState('dailyStatement', ['content']),
  },
  mounted() {
    const { token } = this.$router.currentRoute.query;
    this.getDailyStatement({token});
    const lang = this.$route.query.lang;
    if (lang !== undefined && lang !== "") {
      i18n.locale = lang;
    }
  },
  methods: {
    ...mapActions('dailyStatement', ['getDailyStatement']),
    showDetail: function(date){
      const { token } = this.$router.currentRoute.query;
      const formatDate = moment(date).format("YYYY/MM/DD");
      const url = `/dailystatementdetail?token=${token}&date=${formatDate}&lang=${i18n.locale}`;
      // window.open(url);
      this.$router.push(url)
    },
    formatAmountWinTotal: function(value){
      if(value === undefined || value === "") return i18n.t('undefined');
      return Number(value).toLocaleString()
    }
  }
}
</script>

